export default __webpack_public_path__ + "static/media/ic_twitter.3b569e0c.svg";